import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import { useFormReadOnly } from '../../../../../common';
import { useTreatmentPlanV3PlanBay } from '../../../../hooks';
import TreatmentFields from './TreatmentFields';
import { useSaveTreatmentField } from '../hooks';
import {
  isTherapyProvisioningDescriptionRequired,
  mapTreatmentPageToSavedValues,
  mapTreatmentPageToValues,
} from '../utils';
import { TREATMENT_FORM_SCHEMA } from '../validationSchema';

import type { TreatmentSectionProps } from './types';

export default function TreatmentSection({
  treatmentPage,
  disabled,
  isUpdating,
  onUpdate,
}: TreatmentSectionProps) {
  const readOnly = useFormReadOnly();
  const planBay = useTreatmentPlanV3PlanBay();
  const initialValues = useMemo(() => mapTreatmentPageToValues(treatmentPage), [treatmentPage]);
  const savedValues = useMemo(() => mapTreatmentPageToSavedValues(treatmentPage), [treatmentPage]);
  const formik = useFormik({
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: TREATMENT_FORM_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveTreatmentField({ formik, onUpdate, savedValues });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit}>
      {isUpdating ? <FProgressBar /> : null}
      <TreatmentFields
        disabled={disabled}
        formik={formik}
        isProvisioningRequired={isTherapyProvisioningDescriptionRequired(planBay)}
        readOnly={readOnly}
        saveField={saveField}
        therapyProvisioningDescription={treatmentPage.therapy_provisioning_description}
      />
    </Box>
  );
}
